var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg333Bf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.948 51.5H164.94799999999998V151.5H64.948z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.448 191.5H165.44799999999998V291.5H65.448z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.698 331.5H165.69799999999998V431.5H65.698z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M406.334 241.663C411.263 165.005 480.269 51.5 347.601 51.5c-111.138 0-118.596 96.192-118.596 190.163 0 84.969 4.044 186.586 106.526 190.163 142.872 4.987 76.281-104.974 70.803-190.163z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg333Bf);
export default __webpack_public_path__ + "static/media/333bf.c204191bc01e4c0b178ec220defb5f58.svg";
export { ForwardRef as ReactComponent };